




























import { Component, Prop, Vue } from 'vue-property-decorator';
import Menu from '@/components/Menu/Menu.vue';
import MainSection from '@/components/MainSection/MainSection.vue';
import Ligne from '@/components/Ligne/Ligne.vue';
import Spinner from '@/components/Spinner.vue';
import Axios from 'axios';

@Component({
	components: {
		Menu,
		MainSection,
		Ligne,
		Spinner
	}
})
export default class Timeline extends Vue {
	public dataReady: boolean = false;

	private checkIfMobile(): void {
		let isMobile = this.$store.getters['getIsMobile'];
		if (
			650 >
				(window.innerHeight || document.documentElement.clientHeight) ||
			950 > (window.innerWidth || document.documentElement.clientWidth)
		) {
			isMobile = true;
		} else {
			isMobile = false;
		}

		this.$store.commit('setIsMobile', isMobile);
	}

	protected beforeMount(): void {
		let _self = this;
		Axios.get('/rs-ligne-du-temps/data.json').then(function(response) {
			_self.$store.commit('initData', response.data);
			_self.dataReady = true;
		});
	}

	protected mounted(): void {
		this.checkIfMobile();

		this.$nextTick(function() {
			window.addEventListener('resize', this.checkIfMobile);
			window.addEventListener('orientationchange', this.checkIfMobile);
		});
	}
}
